module.exports = __webpack_public_path__ + "assets/gov-orange-lg-logo-old-dbbfb9.svg";